import { COLORS_CONFIG_BAR } from '@components/widgets/apacheEchart/Commons'
import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, getHondaCustomerJourney, getNode, GREEN_1, HONDA_COLORS_CONFIG, HONDA_SCALE_3_COLORS, isAllFilterByLevel, RED_1, userHas } from '../commonWidgetsHonda'
import { answeredMapper, invalidMapper, isGeoLocationLeaf } from '../../dashHelper'
import useAccount from '@hooks/useAccount'
import { getLineDetailedRadar } from '../../widgetsLibrary/widgetsLine'



export default {
    title: 'Honda - Venta',
    description: 'Dashboard de Honda - Venta',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        const { geoLocations } = useAccount();
        
        //Para filtra por nivel Distribuidor, todos los filtros deben ser del mismo nivel
        let isGroupLevelDistribuidor = isAllFilterByLevel(geoLocations, filters, 'DISTRIBUIDOR');
        const hasHonda = userHas(geoLocations, "HONDA");
        const hasAcura = userHas(geoLocations, "ACURA");
        
        const widgetsArray = [
            getLineDetailedRadar({
              mainIndicator: 'hon_vta_npm_satisf_gral',
              radialIndicators: [
                'NPS_INICIACION_VENTA',
                'NPS_ASESOR_VENTA',
                'NPS_PRUEBA_MANEJO_VENTA',
                'NPS_FINANCIAMIENTO_VENTA',
                'NPS_ENTREGA_VENTA'
              ],
              radialType: 'byIndicator',
              position: [0, 0],
              size: [4, 3],
              title: 'Satisfacción General',
              groupByLevel: 3,
              extras: {
                formula: 'nps-10', 
                //formula: 'wavg-5',
              },
              extraConfigs: {
                backgroundColor: 'transparent',
                theme: 'dark',
                showRadialChart: true,
                initialVisibleChart: 1,
                formulaRadial: 'wavg-5',
                showSample: false,
              },
              useNormalizedRadial: true,
              normalizeBottom: 0,
              normalizeTop: 10,
              criticalMomentInclude: [1],
              indicatorsNames: {
                'NPS_INICIACION_VENTA': 'Bienvenida',
                'NPS_ASESOR_VENTA': 'Asesor de Ventas',
                'NPS_PRUEBA_MANEJO_VENTA': 'Prueba de Manejo',
                'NPS_FINANCIAMIENTO_VENTA': 'Financiamiento',
                'NPS_ENTREGA_VENTA': 'Entrega',
              },
            }),
            //1

            {
              title: 'Encuestas',
              type: 'label',
              position: [0, 3],
              size: [4, 1],
              config: { color: '#B7AADC' },
            },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                position: [0, 6],
                size: [1, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'hon_vta_npm_recom_prueba',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: HONDA_SCALE_3_COLORS,
                    useCurrent: 0,
                    decimals: 1,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    valueSymbol: '%',
                }
            }),

            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'semicircleGeneric',
              title: 'NPS Marca',
              key: 'nps-por-mes',
              size: [2, 2],
              indicator: 'hon_vta_nps_marca',
              extraConfigs: {
                colors: HONDA_SCALE_3_COLORS,
                categories: ['promoters', 'passives', 'detractors'],
                //groupLabels: { 'promoters': 'Promotores', 'passives': 'Pasivos', 'detractors': 'Detractores' },


                useEmojis: false,
                decimals: 1,
              },
              
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción General',
                position: [1, 6],
                size: [1, 2]    ,
                indicator: 'hon_vta_npm_satisf_gral',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                },
            }),

            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'surveyCountTrendByMonth',
              position: [0, 4],
              size: [1, 2],
              indicator: 'survey-response-counters',
              criticalMomentId: 1,
              extras:{
                sort: { sortBy: 'group', value: 'asc' }
              }
            }),
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'surveyCountTrendByWeek',
              position: [1, 4],
              size: [1, 2],
              indicator: 'survey-response-counters',
              //criticalMomentId: 1,
              extras:{
                sort: { sortBy: 'group', value: 'asc' }
              }
            }),

            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'gaugeGenericByStatus',
              title: 'widgets.calidadDatosVenta',
              //position: [2, 6],
              size: [1, 2],
              mapper: invalidMapper,
              url: 'survey-responses/values',
              //criticalMomentId: 1,
              extraConfigs: {
                decimals: 1,
                maxValue: 100,
                showPercentage: true,
              },
            }),
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'gaugeGenericByStatus',
              title: 'widgets.porcRespuestasVenta',
              //position: [3, 6],
              size: [1, 2],
              mapper: answeredMapper,
              url: 'survey-responses/values',
              //criticalMomentId: 1,
              extraConfigs: {
                decimals: 1,
                maxValue: 100,
                showPercentage: true,
              },
            }),

            getHondaCustomerJourney({
                  id: 'cj-venta1',
                  position: [0, 8],
                  size: [4, 2],
                  indicators: [
                    //{ name: 'hon_vta_recibio_auto', formula: 'count-number' }, //csat
                    { name: 'hon_vta_atencion_rapida', formula: 'wavg-5' }, //atencion
                    { name: 'hon_vta_ejecutivo_vta_interesado', formula: 'wavg-5' },
                    { name: 'hon_vta_instal_agradables', formula: 'wavg-5' }, //facilidad
                    { name: 'hon_vta_prueba_agradable', formula: 'wavg-5' },
                    { name: 'hon_vta_finance_proceso_financiamiento', formula: 'wavg-5' },
                    { name: 'hon_vta_entrega_agil', formula: 'wavg-5' },
                  
                    { name: 'hon_vta_recibio_seguimiento', formula: 'wavg-5' },
                    //{ name: 'hon_vta_tanque_lleno', formula: 'count-number' },
                    //{ name: 'hon_vta_npm_satisf_gral', formula: 'nps-10' }, //nps
                    //{ name: 'hon_vta_npm_recom_prueba', formula: 'nps-10' }, //nps
                    //{ name: 'hon_vta_comment', formula: 'word-count' }, //?
                  ],
                  title: 'Proceso de venta',
            }),

            !isGroupLevelDistribuidor ?
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'rankingByGeoBest',
              title: 'widgets.bestGeoLocationsVentaGrupo',
              position: [2, 10],
              size: [2, 2],
              extraConfigs: {
                backgroundColor: '#501C78',
                titleBackgroundColor: '#88DD76',
                symbol: '',
                showFirstIndex: true,
                id: 'rankingByGeoBestGrupo',
              },
              indicator: 'hon_vta_npm_recom_prueba',
              extras: {
                groupByLevel: 3,        
              },      
            })
            :undefined,

            !isGroupLevelDistribuidor ?
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'rankingByGeoWorst',
              title: 'widgets.worstGeoLocationsVentaGrupo',
              position: [3, 10],
              size: [2, 2],
              extraConfigs: {
                backgroundColor: '#501C78',
                titleBackgroundColor: '#db7476',
                symbol: '',
                showFirstIndex: true,
              },
              indicator: 'hon_vta_npm_recom_prueba',
              extras: {
                groupByLevel: 3,        
              },
            })
            :undefined,

            !isGroupLevelDistribuidor ?
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'rankingByGeoBest',
              title: 'widgets.bestGeoLocationsVentaDist',
              position: [2, 10],
              size: [2, 4],
              extraConfigs: {
                backgroundColor: '#501C78',
                titleBackgroundColor: '#88DD76',
                symbol: '',
                showFirstIndex: true,

                limit: 11,
                maxSlice: 11,
              },
              indicator: 'hon_vta_npm_recom_prueba',     
            })
            :undefined,
            
            !isGroupLevelDistribuidor ?
            getCommonWidget({
              commonWidgets: commonWidgets,
              name: 'rankingByGeoWorst',
              title: 'widgets.worstGeoLocationsVentaDist',
              position: [3, 10],
              size: [2, 4],
              extraConfigs: {
                backgroundColor: '#501C78',
                titleBackgroundColor: '#db7476',
                symbol: '',
                showFirstIndex: true,
                limit: 11,
                maxSlice: 11,
              },
              indicator: 'hon_vta_npm_recom_prueba',
            })
            :undefined,

    {
    title: 'Nube de Palabras / Frecuencia en comentarios',
    position: [0, 13],
    size: [2, 2,],
    config: {
      id: 'word-count',
      type: 'wordCloud',
      mapper: (data: any, extra: any) => {
        return data !== undefined
          && data.map !== undefined
          ? data.map((item: any) => ({
              ...item,
              group: item.group ?? item.category
            }))
          : []
      },      
      indicators: [
        {
          indicator: 'WORD_COUNT',
          keyExtract: ['count', 'value', 'group', 'category'],
          singleton: true,
        },
      ],
    },
  },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestTagsVenta',
      position: [2, 13],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'positive',
        headerBadge: 'Top',
        countLabel: 'menciones',
        color: GREEN_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },
    }),    
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstTagsVenta',
      position: [2, 15],
      size: [2, 2],
      indicator: 'sentiment',
      //criticalMomentId: 1,
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
      extraConfigs: {
        layout: 'signal',
        tone: 'negative',
        headerBadge: 'Atención',
        countLabel: 'menciones',
        color: RED_1,
      },
      extraIndicatorConfigs: {
        limit: 2,
        value: 'count',
      },
    }),
   
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 15],
      size: [4, 3],
      //criticalMomentId: 1,
      extraConfigs:   {
          colors: HONDA_SCALE_3_COLORS, 
          typeColumn: 'percent', 
          //widgetTitle: 'Análisis de sentimientos top 6' ,
          groupKeys: ['positive', 'neutral', 'negative'],
          groupLabels: {'positive': 'Promotores', 'neutral': 'Neutros', 'negative': 'Detractores'},
      },      
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'Diagrama Ishikawa',
      position: [0, 18],
      size: [4, 3],
      indicator: 'sentiment',
      criticalMomentId: 1,
    }),
     {
      title: 'widgets.otherIndicators',
      type: 'label',
      position: [0, 21],
      size: [4, 1],
    },





            
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Calidad de Recepción',
                size: [1, 2]    ,
                indicator: 'hon_vta_atencion_rapida',
                
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Calidad de Instalaciones',
                size: [1, 2]    ,
                indicator: 'hon_vta_instal_agradables',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Calidad de Atención de asesores',
                size: [1, 2]    ,
                indicator: 'hon_vta_ejecutivo_vta_interesado',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Satisfacción tiempo entrega.',
                size: [1, 2]    ,
                indicator: 'hon_vta_entrega_agil',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),
             

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Realizó prueba de manejo',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_vta_realizo_prueba'
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'La prueba de manejo ayudó en toma de decisión',
                size: [1, 2]    ,
                indicator: 'hon_vta_prueba_agradable',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Utilizó financiamiento con Honda Finance',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_vta_compro_finance'
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                title: 'Facilidad del financiamiento con Honda Finance.',
                size: [1, 2]    ,
                indicator: 'hon_vta_finance_proceso_financiamiento',
                extraConfigs: {
                    decimals: 1,
                    maxValue: 100,
                    showPercentage: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieSiNo',
                title: 'Recibió el tanque lleno',
                size: [1, 2],
                extraConfigs: {
                    center: ['50%', '55%'],
                    radius: [20, 70],
                    legendTop: 'top',
                },
                indicator: 'hon_vta_tanque_lleno'
            }),
            


getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.zonalSatisfactionVenta',
      key: 'venta-satisfaction-zona',
      position: [1, 28],
      size: [4, 2],
      indicator: 'hon_vta_npm_recom_prueba',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        showLegend:false,
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      extras: {
        groupByLevel: 2
      },
    }),

    hasHonda?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.grupoSatisfactionHonda',
      key: 'venta-satisfaccion-grupo-honda',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_vta_npm_recom_prueba',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,        
      },
      extras: {
        geoLocationInclude: [1],
        groupByLevel: 3
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    :undefined,

    hasHonda?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.distribuidorSatisfactionHonda',
      key: 'venta-satisfaccion-dist-honda-distribuidor',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_vta_npm_recom_prueba',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,        
      },
      extras: {
        geoLocationInclude: [1],
        groupByLevel: 6
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,

    hasAcura?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.grupoSatisfactionAcura',
      key: 'venta-satisfaccion-dist-acura',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_vta_npm_recom_prueba',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,
      },
      //geoLocationId: 2,
      extras: {
        geoLocationInclude: [2],
        groupByLevel: 3
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    })
    : undefined,

    hasAcura?
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'barByGeo',
      title: 'widgets.distribuidorSatisfactionAcura',
      key: 'venta-satisfaccion-dist-acura',
      position: [0, 30],
      size: [4, 2],
      indicator: 'hon_vta_npm_recom_prueba',
      //criticalMomentId: 1,
      extraConfigs: {
        colors: HONDA_COLORS_CONFIG,
        itemsWidth: 200,
        percentageScale: true,
        decimals: 1,
        maxValue: 100,
        rotateXAxisLegend: true,
        wrapTexts: true,
        labelFontSize: 10,
        showLegend:false,
      },
      //geoLocationId: 2,
      extras: {
        geoLocationInclude: [2],
        groupByLevel: 6
      },
      render: (filters) => {
        return !isGeoLocationLeaf(filters, filtersData)
      },
      mapper: (data: any) => {
        return [...data].sort((a: any, b: any) => b.value - a.value).map((item: any) => ({
          ...item,
          label: item.label !== undefined
            ? item.label.replaceAll('MITSUBISHI ', '')
            : item.label
        }))
      },
    }):
    undefined,

            
    ].filter(w => w != undefined);
    return widgetsArray;
},
} as DasboardConfig
